import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddTraderLayer from "../components/AddTraderLayer";


const AddTraderPage = () => {
  return (
    <>
  
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Trader  </h5><Breadcrumb title="Add Trader" /></div>

        {/* AddUserLayer */}
        <AddTraderLayer />
   
    </>
  );
};

export default AddTraderPage;
